import { Box, Notification, Title } from 'rbx';
import React from 'react';
import { format } from 'date-fns';
import SubscriptionDetails, { LIVE } from './SubscriptionDetails';
import CancelButtons from './CancelButtons';
import OrdersTable from './OrdersTable';
import InvoicesTable from './InvoicesTable';

const date = value => (value ? format(new Date(value), 'do MMM yyyy') : '-');

/**
 * The user's auto-apply (Skyvern) subscription, its live credit balance and
 * cancel actions, and all its charges and invoices below.
 */
function AutoApplySubscription({
  subscription,
  credits,
  history,
  onCancel,
  onRefund,
}) {
  const granted = (subscription && subscription.credits) || {};
  return (
    <Box>
      <Title size={4}>Auto-apply (Skyvern)</Title>
      {!subscription ? (
        <Notification>No auto-apply subscription</Notification>
      ) : (
        <>
          <SubscriptionDetails
            subscription={subscription}
            extra={[
              [
                'Credit balance',
                credits
                  ? `${credits.balance} left of ${credits.perCycle} per cycle`
                  : '-',
              ],
              ['Can apply', credits && credits.canApply ? 'Yes' : 'No'],
              ['Credits granted', date(granted.grantedAt)],
              ['Last renewal', date(granted.renewedAt)],
              ['Carried over at renewal', granted.carriedOver || 0],
              ['Credits period end', date(granted.periodEnd)],
            ]}
          />
          {LIVE.includes(subscription.status) && (
            <CancelButtons
              endingAlready={
                subscription.status === 'will_cancel_at_billing_period_end'
              }
              onCancel={onCancel}
            />
          )}
        </>
      )}
      <OrdersTable orders={history.orders} onRefund={onRefund} showCredits />
      <InvoicesTable invoices={history.invoices} />
    </Box>
  );
}

export default AutoApplySubscription;
